/**
 * Chaves do cache da administração. Ficam FORA da chave da sessão (como `usersKey`, em
 * `features/conversation`): o logout e a troca de conta as descartam junto com o resto, e a conexão
 * do WhatsApp de uma sessão nunca aparece para a pessoa que entrar depois.
 */
export const connectionKey = ['admin', 'whatsapp'] as const;
export const syncKey = ['admin', 'whatsapp-sync'] as const;
/** A conexão com o Bitrix (estado, opções e fila) e as escolhas que o Bitrix oferece (usuários, etapas, origens). */
export const bitrixKey = ['admin', 'bitrix'] as const;
export const bitrixOptionsKey = ['admin', 'bitrix-options'] as const;
/** O Canal Aberto do Bitrix (bate-papo no card): estado do conector e das linhas. */
export const bitrixOpenlinesKey = ['admin', 'bitrix-openlines'] as const;
/** O usuário do Bitrix de cada usuário do CladvApp (Administração → Usuários). */
export const bitrixUserLinksKey = ['admin', 'bitrix-user-links'] as const;
/** A situação de um número no serviço de mensagens (Administração → WhatsApp → Números → Situação do número). */
export const lineStatusKey = (lineId: string) => ['admin', 'line-status', lineId] as const;
/** As contas que o token da conexão alcança (Administração → WhatsApp → Conexão → "Contas que o token alcança"). */
export const accountsKey = ['admin', 'whatsapp-accounts'] as const;
